<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import { useProfile } from '@/entities/profile'

  import { OrdersList } from '@/views/shop/orders'

  definePage({
    meta: { layout: 'baseNew' },
  })

  const router = useRouter()
  const route = useRoute('/my-orders/[[page]]')
  const { isProbationPassed } = storeToRefs(useProfile())

  if (!isProbationPassed.value) {
    router.push('/')
  }

  const { t } = useI18n()

  useHead({
    title: () => t('my_orders_badge'),
  })

  const initialSearch = computed(() => (route.query.search as string | undefined) ?? '')
</script>

<template>
  <div
    class="wide-responsive relative w-full"
    data-testid="my-orders-page"
  >
    <PageDecorationImage />
    <OrdersList :initial-search="initialSearch" />
  </div>
</template>
